import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Stack from "@mui/material/Stack";
import { DashboardContentLayout } from "~ui-components/components/atoms/dashboard-content-layout";
import { BaseMap, BaseMapProps } from "./base-map";
import { LayerGroups, LayerGroupsProps } from "./layer-groups";

export interface LayersProps {
	layerGroupsProps: LayerGroupsProps;
	baseMapProps: BaseMapProps;
	// onCancel: () => void;
	// onSaveChange: () => void;
}

export function Layers({
	layerGroupsProps,
	baseMapProps,
	// onCancel,
	// onSaveChange,
}: LayersProps) {
	return (
		<DashboardContentLayout pageTitle="Layers">
			<Stack
				direction={{ xs: "column", md: "row" }}
				spacing={4}
				sx={{ position: "relative" }}>
				<Box sx={{ flex: "1 1 auto", minWidth: 0 }}>
					<Card>
						<CardContent>
							<Stack spacing={3}>
								<LayerGroups {...layerGroupsProps} />
								<BaseMap {...baseMapProps} />
							</Stack>
						</CardContent>
						{/* <CardActions sx={{ justifyContent: "flex-end" }}>
							<Button
								color="secondary"
								onClick={onCancel}>
								Cancel
							</Button>
							<Button
								variant="contained"
								onClick={onSaveChange}>
								Save changes
							</Button>
						</CardActions> */}
					</Card>
				</Box>
			</Stack>
		</DashboardContentLayout>
	);
}
